<template>
    <v-container fluid class="page-container">
        <div class="welcome">
            <h1 class="welcome-title">Welcome to the Paron administration panel</h1>
            <p class="welcome-subtitle">Pick a section to get started.</p>
        </div>
        <v-row>
            <v-col
                v-for="tile of visibleTiles"
                :key="tile.to"
                cols="12"
                sm="6"
                md="4"
                lg="3"
            >
                <v-card outlined :to="tile.to" class="tile" hover>
                    <v-avatar color="primary" size="44" class="mb-3">
                        <v-icon dark>mdi-{{ tile.icon }}</v-icon>
                    </v-avatar>
                    <div class="tile-title">{{ tile.title }}</div>
                    <div class="tile-text">{{ tile.text }}</div>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    const ADMIN = ['admin']
    const ALL = ['admin', 'dealer']

    export default {
        name: 'HomeRoute',
        data() {
            return {
                tiles: [
                    { title: 'Members', to: '/members', icon: 'account-multiple-outline', text: 'Search, approve and edit members and their cards.', roles: ALL },
                    { title: 'Transactions', to: '/transactions', icon: 'receipt', text: 'Receipts submitted by members, with totals and export.', roles: ALL },
                    { title: 'Partners', to: '/partners', icon: 'storefront-outline', text: 'Stores, VAT numbers and reward rules.', roles: ALL },
                    { title: 'Teams', to: '/teams', icon: 'account-group-outline', text: 'Teams that members belong to.', roles: ALL },
                    { title: 'Cards', to: '/cards', icon: 'card-account-details-outline', text: 'PARON, My Market and AB cards.', roles: ADMIN },
                    { title: 'Offers', to: '/offers', icon: 'sale', text: 'Partner offers shown in the app.', roles: ADMIN },
                    { title: 'Articles', to: '/articles', icon: 'newspaper-variant-outline', text: 'News, announcements and promos.', roles: ADMIN },
                    { title: 'Dealers', to: '/dealers', icon: 'handshake-outline', text: 'Dealer accounts and their logins.', roles: ADMIN }
                ]
            }
        },
        computed: {
            visibleTiles() {
                const user = this.$store.getters.currentUser
                const role = user && user.role
                return this.tiles.filter(tile => tile.roles.includes(role))
            }
        }
    }
</script>

<style scoped>
.welcome {
    margin: 8px 0 24px;
}

.welcome-title {
    font-size: 1.6rem;
    font-weight: 600;
    color: var(--v-primary-base);
}

.welcome-subtitle {
    color: rgba(0, 0, 0, 0.6);
    margin: 4px 0 0;
}

.tile {
    padding: 20px;
    height: 100%;
}

.tile-title {
    font-weight: 600;
    font-size: 1.05rem;
    margin-bottom: 4px;
}

.tile-text {
    font-size: 0.875rem;
    color: rgba(0, 0, 0, 0.6);
}
</style>
